import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

export interface getDeviceList_returns_data_item {
  id: number;
  last_online: string;
  pm25: string;
  stncode: string;
  dev_id: string;
  location: string;
  lat: string;
  long: string;
  aqi: number;
  district?: string | null;
}

export interface getDeviceList_returns_data {
  status: string;
  data: getDeviceList_returns_data_item[];
}

export const getDeviceList = async (): Promise<
  AxiosResponse<getDeviceList_returns_data>
> => {
  const config: AxiosRequestConfig = {
    url: "https://monster1.distronix.in:1443/v1.0/mopr/sens/get_device_list",
    method: "POST",
  };
  const response: AxiosResponse<getDeviceList_returns_data> = await axios(
    config
  );
  return response;
};
